/**
 * Defines the reason why an article is sent to helpdesk to be checked.
 */
export enum CheckArticleReason {
	ModelError = 0,
	PowderCoating = 1,
	ZincCoating = 2,
}
